import React, { useEffect, useState, useRef } from "react";
import {
  View,
  Button,
  TouchableOpacity,
  Text,
  ScrollView,
  Alert,
  StyleSheet,
  Modal,
  FlatList,
} from "react-native";
import { Calendar } from "react-native-calendars";

import { FontAwesome } from "@expo/vector-icons";

import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";
import GlobalStyles from "../../Resources/Styles";

import { Ionicons } from "@expo/vector-icons";
import Bodyweight from "../Firestore/Bodyweight";
import Workout from "../Firestore/Workout";
import { useScreenDimensions, useDevice } from "../_layout";
import { useTranslation } from "react-i18next";
import { observer, Observer } from "mobx-react";
import { format } from "date-fns";
import MultipleSegmentedPicker from "../Components/MultipleSegmentedPicker";
import { use } from "react";
import i18n from "../../Localization/i18next";

const LinkSlotView = observer(({ isVisible, onClose, exercise }) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const block = exercise.workout.block;
  const week = exercise.workout.week;

  const getSlotName = () => {
    const { selectedLift: lift, selectedPriority: priority } = block;
    if (!lift || !priority) return null;

    // strip off trailing '-string'
    const priorityBase = priority.replace(/-string$/, "");
    const liftBase = lift.replace(/-string$/, "");
    // capitalize first letter of lift
    const liftCapitalized =
      liftBase.charAt(0).toUpperCase() + liftBase.slice(1);

    return `${priorityBase}${liftCapitalized}-string`;
  };

  const slotName = getSlotName();
  const weekSlots = block.protocolsAndExercises.filter(
    (ex) => ex.getWeek === week
  );

  let foundFirstSlot = null;
  if (slotName) {
    // Prefer an existing exercise in this workout
    foundFirstSlot =
      weekSlots.find(
        (ex) =>
          ex.protocolSlot === slotName && !ex.isSecondaryProtocol && ex.workout
      ) ||
      weekSlots.find(
        (ex) => ex.protocolSlot === slotName && !ex.isSecondaryProtocol
      );
  }
  // Determine if the first slot came from an exercise in this workout
  const firstFromThisWorkout = Boolean(
    foundFirstSlot && foundFirstSlot.workout
  );

  let foundSecondSlot = null;
  if (slotName) {
    if (firstFromThisWorkout) {
      // Only pick a secondary exercise from the same workout
      foundSecondSlot = weekSlots.find(
        (ex) =>
          ex.protocolSlot === slotName && ex.isSecondaryProtocol && ex.workout
      );
    } else {
      // Fallback: prefer same-workout, but allow any secondary
      foundSecondSlot =
        weekSlots.find(
          (ex) =>
            ex.protocolSlot === slotName && ex.isSecondaryProtocol && ex.workout
        ) ||
        weekSlots.find(
          (ex) => ex.protocolSlot === slotName && ex.isSecondaryProtocol
        );
    }
  }

  const disabled =
    ((!block.selectedLift || !block.selectedPriority) && !foundSecondSlot) ||
    (foundFirstSlot && !block.selectedSecondary);

  //   console.log(
  //     `selectedLift: ${block.selectedLift}, selectedPriority: ${block.selectedPriority} slotName: ${slotName}, LinkSlotView: foundFirstSlot: ${foundFirstSlot}, foundSecondSlot: ${foundSecondSlot}`
  //   );

  useEffect(() => {
    if (block) {
      block.setProperty("selectedLift", null);
      block.setProperty("selectedPriority", null);
      block.setProperty("selectedSecondary", false);
    }
  }, []);

  const cancel = () => {
    onClose();
  };

  const Buttons = ({ bool, disabled }) => {
    const text = bool ? "save-string" : "cancel-string";

    const save = () => {
      if (disabled) return;

      exercise.setProperty("protocolSlot", slotName);
      if (block.selectedSecondary) {
        exercise.setProperty("isSecondaryProtocol", true);
      } else {
        exercise.setProperty("isSecondaryProtocol", false);
      }

      exercise.workout?.setProperty("hasChanged", true);
      if (block.client) {
        block.client.updateClientTransactionData(block.id);
        block.client.startOrResetBatchTimer();
      } else if (block.coach) {
        block.coach.updateCoachTransactionBlocks(block.id);
        block.coach.startOrResetBatchTimer();
      }
      onClose();
    };

    const [isHovered, setIsHovered] = useState(false);

    return bool ? (
      <TouchableOpacity
        onPress={save}
        style={{
          marginLeft: screenSize === "small" ? 8 : 10,
          opacity: disabled ? 0.5 : 1,
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            backgroundColor: Colors.bubbleColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: Colors.bubbleColor,
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
            opacity: isHovered ? 0.7 : 1,
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: Colors.whiteColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    ) : (
      <TouchableOpacity
        onPress={cancel}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: isHovered ? Colors.redColor : Colors.whiteColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: Colors.redColor,
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: isHovered ? Colors.whiteColor : Colors.redColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };

  const LiftPicker = observer(({}) => {
    const pickerOptions = [
      "squat-string",
      "benchPress-string",
      "deadlift-string",
    ];
    const selectedIndex = pickerOptions.indexOf(block.selectedLift);
    const onChange = (index) => {
      block.setProperty("selectedLift", pickerOptions[index]);
    };
    return (
      <MultipleSegmentedPicker
        options={pickerOptions}
        value={selectedIndex}
        onChange={onChange}
      />
    );
  });

  const LiftPriorityPicker = observer(({}) => {
    const pickerOptions = [
      "primary-string",
      "secondary-string",
      "tertiary-string",
      "quaternary-string",
      "quinary-string",
    ];
    const selectedIndex = pickerOptions.indexOf(block.selectedPriority);
    const onChange = (index) => {
      block.setProperty("selectedPriority", pickerOptions[index]);
    };
    return (
      <MultipleSegmentedPicker
        options={pickerOptions}
        value={selectedIndex}
        onChange={onChange}
      />
    );
  });

  const SecondarySlotPicker = observer(({}) => {
    const onChange = (value) => {
      console.log(`SecondarySlotPicker: value: ${value === 0 ? false : true}`);
      block.setProperty("selectedSecondary", value === 0 ? false : true);
    };
    return (
      <MultipleSegmentedPicker
        options={["No", "yes-string"]}
        value={block.selectedSecondary ? 1 : 0}
        onChange={onChange}
        small={true}
      />
    );
  });

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={onClose}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={cancel}
          style={GlobalStyles.touchableBackground}
        >
          <View />
        </TouchableOpacity>
        <View
          style={{
            position: "absolute",
            alignItems: "center",
            width: screenSize !== "small" && 600,
            maxHeight: "90%",
            maxWidth: "90%",
            minWidth: 320,
          }}
          onStartShouldSetResponder={() => false}
        >
          <View
            style={[
              styles.modalView,
              {
                width: "100%",
                padding: screenSize === "small" ? 8 : 24,
              },
            ]}
          >
            <Text
              style={[
                Fonts.bold18Centered,
                { marginBottom: 8, alignSelf: "center" },
              ]}
            >
              {t("linkExerciseToSlot-string")}
            </Text>
            <Text
              style={[
                Fonts.regular14,
                {
                  marginBottom: 16,
                  alignSelf: "center",
                  color: Colors.grayColor,
                  textAlign: "center",
                },
              ]}
              numberOfLines={2}
            >
              {exercise.getName(t, i18n.language)} {"("}
              {block.getWeekName(week)
                ? block.getWeekName(week)
                : t("weekWithNumber-string", {
                    week: week,
                  })}
              {")"}
            </Text>
            <ScrollView
              style={{}}
              contentContainerStyle={{
                flex: 1,
              }}
              horizontal={true}
              showsHorizontalScrollIndicator={false}
            >
              <View style={{}}>
                <Text style={[Fonts.regular14, { marginBottom: 8 }]}>
                  {t("lift-string")}
                </Text>
                <LiftPicker />
                <Text
                  style={[Fonts.regular14, { marginBottom: 8, marginTop: 16 }]}
                >
                  {t("priority-string")}
                </Text>
                <LiftPriorityPicker />
              </View>
            </ScrollView>
            {foundFirstSlot && !foundSecondSlot && (
              <>
                {foundFirstSlot?.workout?.id === exercise?.workout?.id ? (
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: 24,
                    }}
                  >
                    <Text style={[Fonts.regular14, { marginRight: 16 }]}>
                      <Text
                        style={[Fonts.regular14, { color: Colors.redColor }]}
                      >
                        {"*"}
                      </Text>
                      {t("alreadyOneExerciseForSlot-string", {
                        exerciseName: foundFirstSlot.getName(t, i18n.language),
                      })}
                    </Text>
                    <SecondarySlotPicker />
                  </View>
                ) : (
                  <Text style={[Fonts.regular14, { marginTop: 24 }]}>
                    <Text style={[Fonts.regular14, { color: Colors.redColor }]}>
                      {"*"}
                    </Text>
                    {t("alreadyOneExerciseForSlotAnotherWorkout-string", {
                      exerciseName: foundFirstSlot.getName(t, i18n.language),
                    })}
                  </Text>
                )}
              </>
            )}
            {foundFirstSlot && foundSecondSlot && (
              <Text style={[Fonts.regular14, { marginTop: 24 }]}>
                <Text style={[Fonts.regular14, { color: Colors.redColor }]}>
                  {"*"}
                </Text>
                {t("ThisSlotIsFull-string", {
                  firstExerciseName: foundFirstSlot.getName(t, i18n.language),
                  secondExerciseName: foundSecondSlot.getName(t, i18n.language),
                })}
              </Text>
            )}

            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-evenly",
                marginTop: 24,
              }}
            >
              <Buttons bool={false} />
              <Buttons bool={true} disabled={disabled} />
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
});

const styles = StyleSheet.create({
  modalView: {
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
});

export default LinkSlotView;
